import { ColocaSurface } from "@/shared/components/layout/ColocaSurface";

export interface PayinConfirmRow {
  label: string;
  value: string;
}

export interface PayinConfirmSummaryProps {
  /** Eyebrow above the rows — e.g. "Monto". */
  title: string;
  rows: PayinConfirmRow[];
}

/**
 * The money trail shown before a payin is created: the same numbers the preview already displayed, so
 * confirming holds no surprise.
 *
 * Rows arrive fully formatted and already translated. Copy is the caller's because the two surfaces describe
 * the same operation from opposite sides — a wallet owner is topping up ("el pagador envía"), a collector is
 * charging someone else ("vas a cobrar") — and neither namespace should have to own the other's words.
 */
export function PayinConfirmSummary({ title, rows }: PayinConfirmSummaryProps) {
  return (
    <ColocaSurface variant="muted" padding="md" className="rounded-xl">
      <p className="mb-3 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{title}</p>
      <div className="divide-y divide-border/60">
        {rows.map((row) => (
          <div key={row.label} className="flex items-start justify-between gap-4 py-2">
            <span className="shrink-0 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {row.label}
            </span>
            <span className="text-right text-sm text-foreground">{row.value}</span>
          </div>
        ))}
      </div>
    </ColocaSurface>
  );
}
